import {distance, Interval, Note, transpose} from "tonal";
import {clefBassTransform, generateRandomArray, noteObjToStr} from "./helpers";

/**
 * 4: 大三度 (3M)
 * 16: 大三度 + 八度
 * 28: 大三度 + 八度 * 2
 * 40: 大三度 + 八度 * 3
 * 52: 大三度 + 八度 * 4
 * 3: 小三度 (3m)
 * 15: 小三度 + 八度
 * 27: 小三度 + 八度 * 2
 * 39: 小三度 + 八度 * 3
 * 51: 小三度 + 八度 * 4
 * 9: 大六度 (6M)
 * 21: 大六度 + 八度
 * 33: 大六度 + 八度 * 2
 * 45: 大六度 + 八度 * 3
 * 57: 大六度 + 八度 * 4
 * 8: 小六度 (6m)
 * 20: 小六度 + 八度
 * 32: 小六度 + 八度 * 2
 * 44: 小六度 + 八度 * 3
 * 56: 小六度 + 八度 * 4
 *
 * 2M/2m: 大/小二度
 * 3M/3m: 大/小三度
 * 4P: 纯四度
 * 5P: 纯五度
 * 5d: 减五度
 * 6M/6m: 大/小六度
 * 8P: 纯八度
 *
 */

export const removeAcc = (note: string, baseNote: string) => {
    let _note: any = Note.get(note)
    let interval = Interval.get(distance(_note, baseNote))

    if (!_note.empty && _note.acc) {
        _note = _note.letter +_note.oct
        interval = Interval.get(distance(_note, baseNote))
    }

    const relation = Interval.simplify(Interval.fromSemitones(interval.semitones || 0))

    return {_note, relation}
}

export const l = (...args: any) => {
    args.forEach((value: any) => {
        console.log(value);
    });
}

export const noteTo12 = (key: string, accidentals: string) => {

    let val = 0

    let arrow = null

    switch (key) {
        case 'C':
            val = 0
            if (accidentals === '#') {
                arrow = 'up'
                val = 1
            }
            if (accidentals === 'b') {
                val = 11
            }
            break

        case 'D':
            val = 2
            if (accidentals === '#') {
                val = 3
                arrow = 'up'
            }
            if (accidentals === 'b') {
                val = 1
                arrow = 'down'
            }
            break

        case 'E':
            val = 4
            if (accidentals === '#') {
                val = 5
            }
            if (accidentals === 'b') {
                val = 3
                arrow = 'down'
            }
            break

        case 'F':
            val = 5
            if (accidentals === '#') {
                val = 6
                arrow = 'up'
            }
            if (accidentals === 'b') {
                val = 4
            }
            break

        case 'G':
            val = 7
            if (accidentals === '#') {
                val = 8
                arrow = 'up'
            }
            if (accidentals === 'b') {
                val = 6
                arrow = 'down'
            }
            break

        case 'A':
            val = 9
            if (accidentals === '#') {
                val = 10
                arrow = 'up'
            }
            if (accidentals === 'b') {
                val = 8
                arrow = 'down'
            }
            break

        case 'B':
            val = 11
            if (accidentals === '#') {
                val = 0
            }
            if (accidentals === 'b') {
                val = 10
                arrow = 'down'
            }
            break

    }

    return {val, arrow}
}

const numberToNote = (val: number, accidentals: string) => {
    let note = 'C'

    switch (val) {
        case 0:
            note = 'C'
            break

        case 1:
            if (accidentals === 'up')
                note = 'C'
            if (accidentals === 'down')
                note = 'D'
            break

        case 2:
            note = 'D'
            break

        case 3:
            if (accidentals === 'up')
                note = 'D'
            if (accidentals === 'down')
                note = 'E'
            break

        case 4:
            note = 'E'
            break

        case 5:
            note = 'F'
            break

        case 6:
            if (accidentals === 'up')
                note = 'F'
            if (accidentals === 'down')
                note = 'G'
            break

        case 7:
            note = 'G'
            break

        case 8:
            if (accidentals === 'up')
                note = 'G'
            if (accidentals === 'down')
                note = 'A'
            break

        case 9:
            note = 'A'
            break

        case 10:
            if (accidentals === 'up')
                note = 'A'
            if (accidentals === 'down')
                note = 'B'
            break

        case 11:
            note = 'B'
            break

    }
    return note
}


// 判断是否大跳 (两个音符的差在7个半音以上)
export const noteJumping = (preceding_note: string, previous_note: string) => {
    const intervalObj = Interval.get(distance(preceding_note, previous_note))
    if (!intervalObj.empty) {
        const semitones = Math.abs(intervalObj.semitones)
        return {is_jumping: semitones > 7, direction: intervalObj.dir}
    }
    return {is_jumping: false, direction: 0}
}

// 匹配音程
export const matchChords = (section: any, stepNotes: Array<string>, baseNote: string, previousChord: string, interval: string, options: { step: string, restrict: string }) => {
    let _note = ''
    let relation = ''
    let relations: string[] = []
    let intervalName = ''
    if (interval === '36') {
        relations = ['3M', '-3M', '3m', '-3m', '6M', '-6M', '6m', '-6m']
        intervalName = '三/六'
    }
    if (interval === '58') {
        if (options.restrict === 'disable_octave') {
            relations = ['5P', '-5P']
        } else if (options.restrict === 'disable_fifth') {
            relations = ['1P', '-1P', '8P', '-8P']
        } else {
            relations = ['5P', '-5P', '1P', '-1P', '8P', '-8P']
        }
        intervalName = '五/八'
    }
    if (interval === '4') {
        relations = ['4P', '-4P']
        intervalName = '纯四'
    }
    stepNotes.forEach(note => {
        const interval = Interval.get(distance(note, baseNote))
        if (!_note && !interval.empty) {
            // 不考虑八度间隔，获取简化的音程关系
            const _relation = Interval.simplify(Interval.fromSemitones(interval.semitones))
            if (relations.indexOf(_relation) !== -1) {
                console.log(
                    `【小节:${section.section_index};音符顺序:${section.note_index}】 前一个音符${previousChord}【${options.step}】前后匹配到${intervalName}度音程${note}, 与旋律部分构成音程关系${_relation}`)
                _note = note
                relation = _relation
            }
        }
    })
    return {note: _note, relation: relation}
}

const matchChordsTraverse = (section: any, stepNotes: Array<string>, baseNote: string, previousChord: string, options: {step: string, restrict: string}) => {
    let _rst = matchChords(section, stepNotes, baseNote, previousChord, '36', options)
    if (!_rst.note) {
        // 如果没有对应的三六度，就尝试匹配纯五、纯八
        _rst = matchChords(section, stepNotes, baseNote, previousChord, '58', options)
    }
    if (!_rst.note) {
        // 最后适配纯4度
        _rst = matchChords(section, stepNotes, baseNote, previousChord, '4', options)
    }
    return _rst
}

/**
 * 优先级进，并尽量适配3、6度音程
 * @param section
 * @param previousMelody
 * @param previousChord
 * @param baseNote
 * @param restrict allow_same_note: 允许三度内插入相同的音 | no_same_note: 不允许三度内插入相同的音 | disable_octave: 禁止八度关系 | disable_fifth: 禁止五度关系
 */
export const generateStepNote = (
    section: any,
    previousMelody: string,
    previousChord: string,
    baseNote: string,
    restrict: string = 'allow_same_note',
) => {
    const melodyTrend = Interval.get(distance(previousMelody, baseNote))
    let dir = melodyTrend.dir as number
    let stepNotes: Array<any> = [] // 用于存储大三度内的音程
    let jumpNotes: Array<any> = [] // 用于存储大三度以外的音程，不包含增四、减五、小七、大七
    let _note = ''
    let relation = ''
    let hasAcc = false
    if (Note.get(previousChord).acc || Note.get(baseNote).acc) {
        hasAcc = true
    }
    if ((Note.get(previousChord).oct as number) >= 4) { // 低音区音节太靠上，强行向下查找
        dir = 1
    }
    // console.log(Interval.simplify(distance('E4', 'F4')))
    // 首先级进，找到前一个音符上下范围大三度以内的各个音
    generateRandomArray(3).forEach(num => {
        if (restrict === 'allow_same_note' && num === 1) {
            stepNotes.push(previousChord)
            return
        }
        if (num !== 1) {
            // 按照旋律部分相反的反向查找低音声部的骨架
            let interval = dir === 1 ? (-num + "M") : (num + "M")
            // 大三度音程的半音数为 4
            stepNotes.push(Note.simplify(transpose(previousChord, interval)))
            interval = dir === 1 ? (-num + "m") : (num + "m")
            stepNotes.push(Note.simplify(transpose(previousChord, interval)))
        }
    })
    // 跳进，找到前一个音符上下范围内纯4、纯5、大小六、八度的音程
    generateRandomArray(5).forEach(num => {
        let interval = ''
        if (num === 1) { // 纯四
            interval = dir === 1 ? '-4P' : '4P'
        }
        if (num === 2) { // 纯五
            interval = dir === 1 ? '-5P' : '5P'
        }
        if (num === 3) { // 大六
            interval = dir === 1 ? '-6M' : '6M'
        }
        if (num === 4) { // 小六
            interval = dir === 1 ? '-6m' : '6m'
        }
        if (num === 5) { // 纯八
            interval = dir === 1 ? '-8P' : '8P'
        }
        jumpNotes.push(Note.simplify(transpose(previousChord, interval)))
    })

    // 过滤升降音
    if (!hasAcc) {
        stepNotes = stepNotes.filter(note => !Note.get(note).acc)
        jumpNotes = jumpNotes.filter(note => !Note.get(note).acc)
    }


    // 顺次匹配>>级进<<后的音符与旋律部分的三六、五八、纯四 音程
    let _rst = matchChordsTraverse(section, stepNotes, baseNote, previousChord, {step: '级进', restrict})
    if (!_rst.note) {
        // 顺次匹配>>跳进<<后的音符与旋律部分的三六、五八、纯四 音程
        _rst = matchChordsTraverse(section, jumpNotes, baseNote, previousChord, {step: '跳进', restrict})
    }

    // 如果全都没有对应的三六、五八、纯四度和弦，就找一个任意的级进
    if (!_rst.note) {
        _note = stepNotes[0]
        const interval = Interval.get(distance(_note, baseNote))
        relation = Interval.fromSemitones(interval.semitones || 0)
        console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 前一个音符${previousChord}【级进】与【跳进】均没有匹配到与旋律部分构成的【三/六】【五/八】【纯四】度音程, 插入级进音符${_note}, 与旋律部分的音程关系${Interval.simplify(relation)}`)
    } else {
        _note = _rst.note;
        relation = _rst.relation
    }
    return {_note, relation}
}

// 生358度音程
export const generate358IntervalNote = (baseNote: string) => {
    const randomInteger = Math.floor(Math.random() * 3) + 1
    let _note = ''
    let relation = ''
    // 先向下找3、5、8音程，再下沉到低音区
    switch (randomInteger) {
        case 1:
            _note = transpose(baseNote, '8P')
            relation = '8P'
            break
        case 2:
            _note = transpose(baseNote, '-5P')
            relation = '5P'
            break
        case 3:
            _note = transpose(baseNote, '-3M')
            relation = '3M'
            // 判断是否有升降，和旋律保持一致
            if (Note.get(_note).acc && !Note.get(baseNote).acc) {
                _note = transpose(baseNote, '-3m')
                relation = '3m'
            }
            break
    }

    // 去除升降音符
    if (Note.get(_note).acc) {
        const rst = removeAcc(_note, baseNote)
        console.log(`【小节:0;音符顺序:0】原始匹配音符${_note}, 音程关系${relation}, 去除升降音变为${rst._note}, ${rst.relation}`)
        _note = rst._note
        relation = rst.relation
    }

    /**
     * 下沉到octave = 3
     */
    const key = _note.slice(0, _note.length - 1)
    const octave = ['F', 'G', 'A', 'B'].indexOf(key[0]) !== -1 ? 2 : 3

    return { _note: `${key}3`, relation }
}

// 生成58度音程
export const generate58IntervalNote = (section: any, baseNote: string) => {
    // 平行三六度、同音反复检测失败，插入5/8度音程
    const randomInteger = Math.floor(Math.random() * 3) + 1
    let _note = ''
    let relation = ''
    switch (randomInteger) {
        case 1:
            // 纯五度
            _note = transpose(baseNote, '-5P')
            relation = '5P'
            break
        case 2:
            // 减五度
            _note = transpose(baseNote, '-5d')
            relation = '5d'
            break
        case 3:
            _note = transpose(baseNote, '8P')
            relation = '8P'
            break
    }
    // 去除升降音符
    if (Note.get(_note).acc) {
        const rst = removeAcc(_note, baseNote)
        console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】生成五/八度音程原始匹配音符${_note}, 音程关系${relation}, 去除升降音变为${rst._note}, ${rst.relation}`)
        _note = rst._note
        relation = rst.relation
    }

    // 下沉到octave = 2
    const key = _note.slice(0, _note.length - 1)
    console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】超过平行三六度限制, 插入与旋律部分构成五/八度的音符${key}2, 与旋律部分的音程关系${relation}`)
    return { _note: `${key}2`, relation }
}

// 查找前面两个音符
export const findPreviousTwoNote = (
    // 当前note在所属小节的位置
    currentNoteIndex: number,
    // 当前小节的位置
    currentBarIndex: number,
    // 高音谱区
    melodyStaves: any,
    // 低音谱区
    chordStructs: any,
    // 音符和骨架的对应关系
    melodyNum: number
) => {

    // 从低音区入手，直接拿到对应的上一个和上上一个音符
    let _tempChords = ['', '']
    let _tempMelody = ['', '']
    chordStructs.forEach((notes: Array<string>, barIndex: number) => {
        notes.forEach((note: string, noteIndex: number) => {
            _tempChords.push(note)
            _tempChords.shift()
            // 找到对应的旋律音符
            const currentMelody = melodyStaves[barIndex].notes[0]
            const currentBarDuration = currentMelody.duration
            // 分情况讨论
            if (melodyNum === 1) {
                // 每一个旋律对应一个和弦
                _tempMelody.push(melodyStaves[barIndex].notes[noteIndex])
                _tempMelody.shift()
            }
            if (melodyNum === 2) {
                // 每两个旋律对应一个和弦
                if (currentBarDuration === '1' || currentBarDuration === '2') {
                    // 当前小节是全音符 或者是 二分音符
                    _tempMelody.push(melodyStaves[barIndex].notes[0])
                    _tempMelody.shift()
                }
                if (currentBarDuration === '4') {
                    // 当前小节是四分音符, 只获取旋律部分的第一个和第三个音
                    if (melodyStaves[barIndex].notes[0]) {
                        _tempMelody.push(melodyStaves[barIndex].notes[0])
                        _tempMelody.shift()
                    }
                    if (melodyStaves[barIndex].notes[2]) {
                        _tempMelody.push(melodyStaves[barIndex].notes[2])
                        _tempMelody.shift()
                    }
                }
            }
            if (melodyNum === 4) {
                // 每小节只有一个和弦
                _tempMelody.push(melodyStaves[barIndex].notes[0])
                _tempMelody.shift()
            }
        })
    })
    _tempMelody = _tempMelody.map(note => noteObjToStr(note))

    return { previousMelody: _tempMelody[1], previousChord: _tempChords[1], precedingMelody:  _tempMelody[0], precedingChord: _tempChords[0] }
}

// 判断平行三六度、同音反复
export const checkParallel = (
    currentNoteIndex: number,
    currentBarIndex: number,
    melodyStaves: any,
    chordStaves: any,
    baseNote: string,
    _note: string
): boolean => {
    let is3Parallel = 0
    let is6Parallel = 0
    let isSameNote = 0
    let parallelAllow = true

    for (let _n = 0; _n < 3; _n++) {
        /**
         * 1. 获取上一个小节的平行三六度
         * 2. 和当前和弦的平行三六度进行对比
         * 3. 如果相同则累加数值，并判断是否已经超出了4个以内的限制
         */
        currentNoteIndex = currentNoteIndex- 1
        if (currentNoteIndex < 0) {
            // 当前音符已经是这个小节的第一个音符，则向上一个小节去查询
            currentBarIndex = currentBarIndex - 1
            // 如果当前小节已经是第一个小节，则不再判断平行3、6度
            if (currentBarIndex < 0) {
                break
            } else {
                // 当来到新的小节，则把current note index赋给当前小节最后一个音符
                currentNoteIndex = melodyStaves[currentBarIndex].notes.length - 1
            }
        }
        const melodyNote = melodyStaves[currentBarIndex].notes[currentNoteIndex]
        const chordNote = chordStaves[currentBarIndex][currentNoteIndex]
        const intervalName = Interval.simplify(distance(noteObjToStr(melodyNote), chordNote)) // 相差音程
        if (intervalName === '-3m' || intervalName === '-3M') {
            is3Parallel += 1
        }
        if (intervalName === '-6m' || intervalName === '-6M') {
            is6Parallel += 1
        }
        if (chordNote === _note) {
            isSameNote += 1
        }
        // 如果平行三度超过了限制
        if (is3Parallel === 3) {
            parallelAllow = false
        }
        // 如果平行六度超过了限制
        if (is6Parallel === 3) {
            parallelAllow = false
        }
        // 同音反复不超过4个
        if (isSameNote === 3) {
            parallelAllow = false
        }
    }

    return parallelAllow
}

export const handleJumping = (section: any, previousChord: string, precedingChord: string, baseNote: string, note: string) => {
    // console.log(Interval.simplify(Interval.invert(distance('C4', 'A3'))), distance('A3', 'C4'))
    let intervalName = ''
    // 判断是否大跳
    if (previousChord && precedingChord) {
        const hasJump = noteJumping(precedingChord, previousChord)
        if (hasJump.is_jumping) {
            const direction = hasJump.direction
            console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 前两个音符${precedingChord},${previousChord}发生大跳，进行反向级进`)
            // 反向级进
            const stepNotes: Array<string> = []
            generateRandomArray(3).forEach(num => {
                if (num !== 1) {
                    // 按照旋律部分相反的反向查找低音声部的骨架
                    let interval = direction > 0 ? (-num + "M") : (num + "M")
                    // 大三度音程的半音数为 4
                    stepNotes.push(Note.simplify(transpose(previousChord, interval)))
                }
            })
            // 反向级进后匹配
            const _rst = matchChordsTraverse(section, stepNotes, baseNote, previousChord, {step: '级进', restrict: ''})
            if (!_rst.note) {
                note = stepNotes[0]
                const interval = Interval.get(distance(note, baseNote))
                console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 反向【级进】后, 前一个音符${previousChord}没有匹配到与旋律部分构成的【三/六】【五/八】【纯四】度音程, 插入级进音符${note}, 与旋律部分的音程关系${Interval.simplify(Interval.fromSemitones(interval.semitones as number))}`)
            } else {
                note = _rst.note;
            }
        }
    }
    // 找到对应旋律的音程
    const interval = Interval.get(distance(note, baseNote))
    if (!interval.empty) {
        intervalName = Interval.simplify(Interval.fromSemitones(interval.semitones))
    }
    return { _note: note, relation: intervalName }
}

/**
 *
 * @param section
 * @param previousMelody
 * @param previousChord
 * @param currentMelody
 * @param note
 * 避免平行八度
 * 一个八度：8P
 * 两个八度：15P
 * 三个八度：22P
 */
export const handleParallelOctave = (
    section: any,
    previousMelody: string,
    previousChord: string,
    currentMelody: string,
    note: string,
    ) => {
    let relation = ''
    const previousInterval = Interval.simplify(distance(previousMelody, previousChord))
    const currentInterval = Interval.simplify(distance(currentMelody, note))

    const perfectOctave = ['1P', '-1P', '-8P', '8P']

    if (perfectOctave.indexOf(previousInterval) !== -1 && perfectOctave.indexOf(currentInterval) !== -1) {
        /**
         * 发生了平行八度关系，新的note直接给塞一个级进并且纵向3/6度
         */
        console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 进入平行八度检查`)
        const rst = generateStepNote(section, previousMelody, previousChord, currentMelody, 'disable_octave')
        console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 触发平行八度${previousMelody},${previousChord},${currentMelody},${note}, 更新二声部骨架${rst._note}`)
        note = rst._note
        relation = rst.relation
    }

    return { _note: note, relation }
}

/**
 * @param section
 * @param previousMelody
 * @param previousChord
 * @param currentMelody
 * @param note
 * 避免平行五度
 * 纯五度：5P (7个半音)
 * 减五度：5d (6个半音)
 */
export const handleParallelFifth = (
    section: any,
    previousMelody: string,
    previousChord: string,
    currentMelody: string,
    note: string,
    ) => {
    let relation = ''
    const previousInterval = Interval.simplify(distance(previousChord, previousMelody))
    const currentInterval = Interval.simplify(distance(note, currentMelody))

    const parallelFifth = ['5P', '-5P']

    if (parallelFifth.indexOf(previousInterval) !== -1 && parallelFifth.indexOf(currentInterval) !== -1) {
        /**
         * 发生了平行五度关系，新的note直接给塞一个级进并且纵向3/6度
         */
        console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 进入平行五度检查`)
        const rst = generateStepNote(section, previousMelody, previousChord, currentMelody, 'disable_fifth')
        console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 触发平行五度${previousMelody},${previousChord},${currentMelody},${note}, 更新二声部骨架${rst._note}`)
        note = rst._note
        relation = rst.relation
    }

    return { _note: note, relation }
}

/**
 * 避免隐伏五八度
 * @param section
 * @param previousMelody
 * @param previousChord
 * @param currentMelody
 * @param note
 *
 */
export const handleHiddenOctaveFifth = (
    section: any,
    previousMelody: string,
    previousChord: string,
    currentMelody: string,
    note: string
) => {
    let relation = ''
    // 高声部音程
    const melodyInterval = Interval.get(distance(previousMelody, currentMelody))
    // 低声部音程
    const chordInterval = Interval.get(distance(previousChord, note))
    // 上一个二声部音程
    const previousInterval = Interval.simplify(distance(previousChord, previousMelody))
    // 当前二声部音程
    const currentInterval = Interval.simplify(distance(note, currentMelody))

    const perfectOctave = ['-8P', '-1P', '8P', '1P']

    const parallelFifth = ['5P', '-5P']

    if (
        (perfectOctave.indexOf(previousInterval) !== -1 && perfectOctave.indexOf(currentInterval) !== -1) ||
        (parallelFifth.indexOf(previousInterval) !== -1 && parallelFifth.indexOf(currentInterval) !== -1)
    ) {
        /**
         * 如果当前发生了隐伏五八度的行为
         * 高声部跳进和低声部级进的方式禁止
         */
        let melodySemitones = 0
        let chordSemitones = 0
        if (!melodyInterval.empty) melodySemitones = melodyInterval.semitones
        if (!chordInterval.empty) chordSemitones = chordInterval.semitones

        if (melodySemitones > 4 && chordSemitones <= 4) {
            console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 进入隐伏五八检查`)
            // 高声部跳进、低声部级进的情形，禁止。塞一个级进并且纵向3/6度
            const rst = generateStepNote(section, previousMelody, previousChord, currentMelody, 'allow_same_note')
            note = rst._note
            relation = rst.relation
            console.log(`【小节:${section.section_index};音符顺序:${section.note_index}】 触发隐伏五八度${previousMelody},${previousChord},${currentMelody},${note}, 更新二声部骨架${rst._note}`)
        }
    }

    return { _note: note, relation }
}

export const staveDataTransfer = (chordNotes: Array<any>) => {
    const rst: Array<any> = []
    chordNotes.forEach((notes: Array<string>, barIndex: number) => {
        rst[barIndex] = {notes: []}
        notes.forEach((chords: any, n: number) => {
            const chordInfo: {accidentals: Array<any>, duration: string, keys: Array<string>} = {
                accidentals: [],
                duration: chords.duration,
                keys: []
            }
            chords.notes.forEach((note: string, index: number) => {
                let _note: any = clefBassTransform(note, 'base_to_clef')
                _note = Note.get(_note)
                if (_note.acc) {
                    chordInfo.accidentals.push({ index, modifier: _note.acc })
                }
                chordInfo.keys.push(`${_note.letter}/${_note.oct}`)
            })
            rst[barIndex].notes.push(chordInfo)
        })
    })
    return rst
}
